module.exports = __webpack_public_path__ + "static/media/T14-T25-10.da379bb8.svg";